import { Link } from "react-router-dom";

interface LinkItem {
  label: string;
  path: string;
}

interface SectionCardProps {
  icon: string;
  title: string;
  description?: string;
  links: LinkItem[];
}

const iconMap: Record<string, string> = {
  support: "ri-customer-service-2-line",
  subscription: "ri-file-list-line",
  billing: "ri-bank-card-line",
};

export default function SectionCard({ icon, title, description, links }: SectionCardProps) {
  const iconClass = iconMap[icon] || "ri-question-line";

  return (
    <section className="bg-white rounded-2xl border border-gray-200 p-6 mb-5">
      <h3 className="text-xs font-bold text-gray-400 mb-1 uppercase tracking-widest flex items-center gap-2">
        <div className="w-6 h-6 flex items-center justify-center bg-gray-100 rounded-md">
          <i className={`${iconClass} text-gray-500 text-sm`}></i>
        </div>
        {title}
      </h3>
      {description && (
        <p className="text-gray-400 text-xs mb-2 ml-8">{description}</p>
      )}
      <div className="mt-3">
        {links.map((link, idx) => (
          <Link
            key={link.path + idx}
            to={link.path}
            className={`flex items-center justify-between px-4 py-3.5 hover:bg-gray-50 transition-colors cursor-pointer group ${idx < links.length - 1 ? "border-b border-gray-100" : ""}`}
          >
            <span className="text-gray-800 font-medium text-sm">{link.label}</span>
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-gray-700 transition-colors"></i>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
